__turbopack_context__.v({
  "arrowBtn": "PartnersSection-module__ZwQrlG__arrowBtn",
  "arrows": "PartnersSection-module__ZwQrlG__arrows",
  "bottomBar": "PartnersSection-module__ZwQrlG__bottomBar",
  "currentNum": "PartnersSection-module__ZwQrlG__currentNum",
  "header": "PartnersSection-module__ZwQrlG__header",
  "icon": "PartnersSection-module__ZwQrlG__icon",
  "leftBlock": "PartnersSection-module__ZwQrlG__leftBlock",
  "logoCard": "PartnersSection-module__ZwQrlG__logoCard",
  "pageCounter": "PartnersSection-module__ZwQrlG__pageCounter",
  "partnersWrapper": "PartnersSection-module__ZwQrlG__partnersWrapper",
  "sliderContainer": "PartnersSection-module__ZwQrlG__sliderContainer",
  "title": "PartnersSection-module__ZwQrlG__title",
  "totalNum": "PartnersSection-module__ZwQrlG__totalNum",
});
